module.exports = __webpack_public_path__ + "assets/img/title-2b18779b.png";